/**
 * <StatTile> — F044 §9.1. A count of 0 may not be coloured `Positive` (green) — enforced here, not
 * left to the caller's discretion (closes the "zero-count-green" defect).
 */
import type { FC } from 'react';
import { Caption1, Title2, makeStyles, tokens } from '@fluentui/react-components';
import type { ColorIntent } from '../../types';
import { colorIntentToken } from './vocabulary';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    padding: tokens.spacingVerticalM,
  },
  label: {
    color: tokens.colorNeutralForeground3,
  },
});

export interface StatTileProps {
  label: string;
  value: number;
  colorIntent: ColorIntent;
}

export const StatTile: FC<StatTileProps> = ({ label, value, colorIntent }) => {
  const styles = useStyles();

  const effectiveIntent: ColorIntent = value === 0 && colorIntent === 'Positive' ? 'Neutral' : colorIntent;
  if (import.meta.env.DEV && value === 0 && colorIntent === 'Positive') {
    console.error(`<StatTile label="${label}"> was asked to render a zero count as ColorIntent.Positive — downgraded to Neutral (F044 colour discipline).`);
  }

  const { foreground } = colorIntentToken(effectiveIntent);

  return (
    <div className={styles.root}>
      <Caption1 className={styles.label}>{label}</Caption1>
      <Title2 style={{ color: foreground }}>{value}</Title2>
    </div>
  );
};
